import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AccountRegisterResponse } from '@/repositories/generated';

const response: AccountRegisterResponse = {
  email: 'hoge@example.com',
  id: '111',
  loginId: 'loginId',
  name: 'name',
  role: 'SYSTEM_MANAGER',
};

export const accountRegister = http.post(
  createMockEndpoint('/account'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
